import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ChartsModule } from 'ng2-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, CurrencyPipe, registerLocaleData } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import { MatPaginatorIntl } from '@angular/material';
import { CustomPaginator } from './CustomPaginatorConfiguration';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
} from '@angular/material';
import { MAT_STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import localeEs from '@angular/common/locales/es';
import { APP_ROUTING } from './app.routes';

import {
  ApiService,
  AuthGuardInsideService,
  AuthGuardService,
  AuthService,
  EnchufateService,
  ErrorDialogService,
  IncidenciasService,
  LugaresPagoService,
  MainService,
  PagoEjecutadoService,
  UserService,
  VisaService
} from './services';

//import { BasicAuthInterceptor, ErrorInterceptor, LoadingInterceptor } from './helpers';


import { DisableControlDirective, OpenDialogDirective } from './directives/';

import { AppComponent } from './app.component';
import { ContentDialogComponent, ImageDialogComponent, TogglePasswordComponent } from './components/shared/';
import { HomeComponent } from './components/home/home.component';
import { IntroComponent } from './components/home/intro/intro.component';
import { LoginComponent } from './components/home/login/login.component';
import { RegistrationComponent } from './components/home/registration/registration.component';
import { ForgotPasswordComponent } from './components/home/forgot-password/forgot-password.component';
import { UpdatePasswordComponent } from './components/home/update-password/update-password.component';
import { TermsConditionsComponent } from './components/home/registration/terms-conditions/terms-conditions.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BannerComponent } from './components/dashboard/banner/banner.component';
/*init intermediate screen*/
import { RegistrationEndComponent } from './components/home/registation-end/registration-end.component';
/*end intermediate screen*/
import { SupplyService } from './services/supply.service';


import { CustomCurrencyPipe } from './pipes/currency';
import { ReceiptService } from './services/receipt.service';
import { VolumePipe } from './pipes/volume';
import { PaginationComponent } from './components/shared/pagination/pagination.component';
import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { ToastrModule } from 'ngx-toastr';
import { SelectModule } from 'ng2-select';
import { NgxMaskModule } from 'ngx-mask';
import { NewScriptComponent } from './components/shared/script-hack/new-script.component';
import { ParametrosComponent } from './components/parametros/parametros.component';
import { ParameterService } from './services/parameter.service';
import { CodeqrService } from './services/codeqr.service';
import { DetalleParametroComponent } from './components/parametros/detalle-parametro/detalle-parametro.component';
import { CodeConfirmComponent } from './components/home/login/code-confirm/code-confirm.component';
import { ErrorDialogComponent } from './components/shared/error-dialog/error-dialog.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { Globals } from './globals';
import { environment } from '../environments/environment';
import { DefaultComponent } from './components/shared/default/default.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { SafePipe } from './safe.pipe';
import { RequestOptions } from '@angular/http';
import { RegistrarSolicitanteComponent } from './components/registrar-solicitante/registrar-solicitante.component';
import { FinanciamientoDeudaComponent } from './components/financiamiento-deuda/financiamiento-deuda.component';
import { DatosSolicitanteComponent } from './components/datos-solicitante/datos-solicitante.component';
import { MensajeFinanciamientoComponent } from './components/mensaje-financiamiento/mensaje-financiamiento.component';
import { MensajeRegistroComponent } from './components/mensaje-registro/mensaje-registro.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MensajePantallaComponent } from './components/mensaje-pantalla/mensaje-pantalla.component';
import { ConsultaTramiteComponent } from './components/consulta-tramite/consulta-tramite.component';
import { EstadoStepComponent } from './components/consulta-tramite/estado-step/estado-step.component';
import { DatosUsuarioHeaderComponent } from './components/datos-usuario-header/datos-usuario-header.component';
import { TablaDocumentosComponent } from './components/tabla-documentos/tabla-documentos.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { VisorDocumentosComponent } from './components/visor-documentos/visor-documentos.component';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { RedirectGuard } from './redirectguard';
import { AuthInterceptorService } from './auth-interceptor.service';
import { BasicAuthInterceptor } from './helpers/basic-auth.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { LoadingInterceptor } from './helpers/loading.interceptor';
import { DialogoConfirmacionComponent } from './components/dialogo-confirmacion/dialogo-confirmacion.component';
//import { DatosSolicitanteSindashboardComponent } from './components/datos-solicitante-sindashboard/datos-solicitante-sindashboard.component';
//import { ConfigService } from './services/config.service';

// import { HtmlPipe } from './inner-html/innerhtmlpipe';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    DisableControlDirective,
    OpenDialogDirective,
    ImageDialogComponent,
    ContentDialogComponent,
    TogglePasswordComponent,
    HomeComponent,
    IntroComponent,
    BannerComponent,
    LoginComponent,
    RegistrarSolicitanteComponent,
    FinanciamientoDeudaComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    UpdatePasswordComponent,
    TermsConditionsComponent,
    DashboardComponent,
    /*init intermediate screen*/
    RegistrationEndComponent,
    /*end intermediate screen*/
    CustomCurrencyPipe,
    PaginationComponent,
    VolumePipe,
    NewScriptComponent,
    ParametrosComponent,
    DetalleParametroComponent,
    CodeConfirmComponent,
    ErrorDialogComponent,
    ErrorPageComponent,
    DefaultComponent,
    FooterComponent,
    SafePipe,
    DatosSolicitanteComponent,
    MensajeFinanciamientoComponent,
    MensajeRegistroComponent,
    MensajePantallaComponent,
    ConsultaTramiteComponent,
    EstadoStepComponent,
    DatosUsuarioHeaderComponent,
    TablaDocumentosComponent,
    VisorDocumentosComponent,
    ServiciosComponent,
    DialogoConfirmacionComponent//,
    //DatosSolicitanteSindashboardComponent
  ],
  entryComponents: [
    ImageDialogComponent,
    ContentDialogComponent,
    DetalleParametroComponent,
    FinanciamientoDeudaComponent,
    CodeConfirmComponent,
    RegistrarSolicitanteComponent,
    ErrorDialogComponent,
    DatosSolicitanteComponent,
    VisorDocumentosComponent,
    DialogoConfirmacionComponent
  ],
  imports: [
    SweetAlert2Module.forRoot(),
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxCaptchaModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatCardModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatToolbarModule,
    MatMenuModule,
    MatSidenavModule,
    MatMenuModule,
    MatListModule,
    MatTabsModule,
    MatRadioModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSlideToggleModule,
    ChartsModule,
    FormsModule,
    MatStepperModule,
    BlockUIModule.forRoot(),
    NgbModule.forRoot(),
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    SelectModule,
    CommonModule,
    NgxMaskModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.mapKey
    }),
    APP_ROUTING,
    MatExpansionModule,
    PdfViewerModule
  ],
  providers: [
    [RedirectGuard],
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true}, //probanto autenticacion por interceptor
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-PE' },
    {
      provide: MAT_STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    // {provide: LocationStrategy, useClass: HashLocationStrategy},
    ApiService,
    AuthGuardService,
    AuthGuardInsideService,
    AuthService,
    MainService,
    UserService,
    SupplyService,
    ReceiptService,
    IncidenciasService,
    CurrencyPipe,
    LugaresPagoService,
    VisaService,
    ParameterService,
    CodeqrService,
    ErrorDialogService,
    EnchufateService,
    PagoEjecutadoService,
    Globals
    //ConfigService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
